module.exports = __webpack_public_path__ + "static/media/cn.f6609864.svg";